import type { Fn } from '@damilaredev/utils'
import axios from 'axios'
import type { AxiosInstance, AxiosRequestConfig } from 'axios'
import { reloadEnvironmentConfig } from '~/constants'

export type AxiosConfig = Partial<AxiosRequestConfig> & {
  url?: string
  method: string
  data?: any
  params?: Record<string, unknown>
  error?: Fn
  success?: Fn
}

reloadEnvironmentConfig()

export default function useRequest(): AxiosInstance {
  const { token, user } = storeToRefs(useAuthStore())

  const isLiveMode = ref('true')

  return axios.create({
    baseURL: useRuntimeConfig().public.baseUrl,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      ...(user.value && { 'Auth-Key': user.value?.id }),
      ...(token.value && { Authorization: `Bearer ${token.value}` }),
      ...(isLiveMode.value === 'false' && { Environment: 'sandbox' }),
    },
  })
}
